import React from 'react';
import { Check } from '../../shared/components/Icons';

export default function AccountSettings({
  name, setName, saveName, saved,
  user,
  showEmailEdit, setShowEmailEdit, emailNew, setEmailNew, emailPw, setEmailPw,
  emailError, emailSaving, emailSaved, updateEmail,
  currentPw, setCurrentPw, newPw, setNewPw, pwError, pwSaved, changePassword,
  flk1Date, setFlk1Date, flk2Date, setFlk2Date, saveDates,
  showDeleteConfirm, setShowDeleteConfirm, deleteConfirmText, setDeleteConfirmText,
  deletePassword, setDeletePassword, deleteError, deleting, deleteAccount,
}) {
  return (
    <>
      <div className="settings-section">
        <div className="settings-section-title">Account</div>
        <div className="settings-row">
          <div className="settings-row-left">
            <span className="settings-row-label">Display name</span>
          </div>
          <div className="settings-row-right" style={{ gap: 8 }}>
            <input className="settings-text-input" value={name}
              onChange={e => setName(e.target.value)}
              onBlur={saveName}
              onKeyDown={e => e.key === 'Enter' && saveName()} />
            {saved['name'] && <span className="settings-inline-saved"><Check size={12} /> Saved</span>}
          </div>
        </div>
        <div className="settings-row">
          <div className="settings-row-left">
            <span className="settings-row-label">Email</span>
          </div>
          <div className="settings-row-right" style={{ flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <span className="settings-muted-val">{user.email || ''}</span>
              {!showEmailEdit && (
                <button className="settings-action-btn" style={{ padding: '2px 10px', fontSize: 11 }}
                  onClick={() => { setShowEmailEdit(true); }}>
                  Edit
                </button>
              )}
              {emailSaved && <span className="settings-inline-saved"><Check size={12} /> Updated</span>}
            </div>
            {showEmailEdit && (
              <form onSubmit={updateEmail} style={{ display: 'flex', flexDirection: 'column', gap: 6, width: '100%', maxWidth: 280 }}>
                <input className="settings-text-input" type="email" placeholder="New email address"
                  value={emailNew} onChange={e => setEmailNew(e.target.value)} autoFocus />
                <input className="settings-text-input" type="password" placeholder="Current password"
                  value={emailPw} onChange={e => setEmailPw(e.target.value)} />
                {emailError && <span className="settings-error">{emailError}</span>}
                <div style={{ display: 'flex', gap: 6 }}>
                  <button className="settings-action-btn" type="button"
                    onClick={() => { setShowEmailEdit(false); setEmailNew(''); setEmailPw(''); }}>
                    Cancel
                  </button>
                  <button className="settings-save-btn" type="submit"
                    disabled={emailSaving || !emailNew.trim() || !emailPw.trim()}>
                    {emailSaving ? 'Saving' : 'Save email'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
        <div className="settings-pw-block" style={{ paddingLeft: 'var(--sp-4)' }}>
          <span className="settings-row-label" style={{ marginBottom: 8, display: 'block' }}>Change password</span>
          <form className="settings-pw-form" onSubmit={changePassword}>
            <input className="settings-text-input" type="password" placeholder="Current password"
              value={currentPw} onChange={e => setCurrentPw(e.target.value)} autoComplete="current-password" />
            <input className="settings-text-input" type="password" placeholder="New password (8+ characters)"
              value={newPw} onChange={e => setNewPw(e.target.value)} autoComplete="new-password" />
            {pwError && <span className="settings-error">{pwError}</span>}
            {pwSaved && <span className="settings-inline-saved"><Check size={12} /> Password updated</span>}
            <button className="settings-save-btn" type="submit" style={{ alignSelf: 'flex-start' }}>
              Update password
            </button>
          </form>
        </div>
      </div>

      <div className="settings-section settings-section--danger">
        <div className="settings-section-title" style={{ color: 'var(--red)' }}>Danger zone</div>
        {!showDeleteConfirm ? (
          <div className="settings-row">
            <div className="settings-row-left">
              <span className="settings-row-label">Delete my account</span>
              <span className="settings-row-key">Permanently deletes your account and all data</span>
            </div>
            <div className="settings-row-right">
              <button className="settings-delete-btn" onClick={() => setShowDeleteConfirm(true)}>
                Delete account
              </button>
            </div>
          </div>
        ) : (
          <div style={{ padding: 'var(--sp-3) var(--sp-4)' }}>
            <p style={{ fontSize: 13, color: 'var(--text)', marginBottom: 12, fontWeight: 600, lineHeight: 1.5 }}>
              This permanently deletes your account and all data. This action cannot be undone.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <input className="settings-text-input" placeholder='Type "DELETE" to confirm'
                value={deleteConfirmText} onChange={e => setDeleteConfirmText(e.target.value)} />
              <input className="settings-text-input" type="password" placeholder="Enter your password"
                value={deletePassword} onChange={e => setDeletePassword(e.target.value)} />
              {deleteError && <span className="settings-error">{deleteError}</span>}
              <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                <button className="settings-action-btn" onClick={() => {
                  setShowDeleteConfirm(false);
                  setDeleteConfirmText('');
                  setDeletePassword('');
                }}>Cancel</button>
                <button className="settings-delete-btn"
                  disabled={deleteConfirmText !== 'DELETE' || !deletePassword.trim() || deleting}
                  onClick={deleteAccount}>
                  {deleting ? 'Deleting' : 'Permanently delete account'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
